import type { Transparency, ViewOptionsGroup } from '@/engine/app/interfaces';
import type { ICommand } from '@/engine/app/modules/core/interfaces/Command';
import type { ViewsService } from '@/engine/app/Views.service';

export class SetGroupTransparencyCommand implements ICommand {
  private readonly _viewsService: ViewsService;

  private readonly _viewOptionsGroup: ViewOptionsGroup;

  private readonly _targetTransparency: Transparency;

  private readonly _previousTransparency: Map<string, Transparency> = new Map();

  public constructor(viewsService: ViewsService, viewOptionsGroup: ViewOptionsGroup, targetTransparency: Transparency) {
    this._viewsService = viewsService;
    this._viewOptionsGroup = viewOptionsGroup;
    this._targetTransparency = targetTransparency;
  }

  public execute(): Promise<boolean> {
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }

    for (const viewOption of this._viewOptionsGroup.children) {
      for (const object of objects) {
        if (viewOption.descriptors.includes(object.descriptor)) {
          this._previousTransparency.set(object.descriptor, object.transparency);
          object.setTransparency(this._targetTransparency);
        }
      }
    }
    return Promise.resolve(true);
  }

  public undo(): Promise<boolean> {
    if (this._previousTransparency === undefined) {
      return Promise.resolve(false);
    }
    const objects = this._viewsService.currentView?.getObjects();
    if (!objects) {
      return Promise.resolve(false);
    }
    for (const viewOption of this._viewOptionsGroup.children) {
      for (const object of objects) {
        if (viewOption.descriptors.includes(object.descriptor)) {
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          object.setTransparency(this._previousTransparency.get(object.descriptor)!);
        }
      }
    }
    return Promise.resolve(true);
  }
}
